/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import type { TView } from '@shared/types/view';
import { removeNullishFromObj } from '@src/shared/utils/helpers/remove-nullish-from-obj';
import { isEqual } from 'lodash';
import { useMemo } from 'react';

type TNames = TView['visible_static_fields']['names'];

export const useNames = (view?: TView) => {
  const viewNames = useMemo(
    () => removeNullishFromObj<TNames>(view?.visible_static_fields.names),
    [JSON.stringify(view?.visible_static_fields.names)]
  );

  const [columnNames, setNewNames] = useState<TNames>(viewNames);
  useEffect(() => {
    setNewNames(viewNames);
  }, [viewNames]);

  const setColumnNames = (record: TNames) => {
    const updatedNames = removeNullishFromObj<TNames>(record);
    setNewNames(updatedNames);
  };

  return {
    columnNames,
    setColumnNames,
    isNamesChanged: !isEqual(columnNames, viewNames),
  };
};
